import React from 'react';

export function BoardFiltersTourTooltip({
  backProps,
  index,
  isLastStep,
  primaryProps,
  size,
  step,
  tooltipProps,
}) {
  const noButtons = Boolean(step.data?.noButtons);
  const showBack = !noButtons && index > 0;
  const showPrimary = !noButtons;
  const clickToContinue = Boolean(step.data?.clickToContinue);

  return (
    <div className="board-filters-tour-tooltip" {...tooltipProps}>
      {step.title ? (
        <h4 className="board-filters-tour-tooltip__title">{step.title}</h4>
      ) : null}
      <div className="board-filters-tour-tooltip__content">{step.content}</div>
      {clickToContinue ? (
        <p className="board-filters-tour-tooltip__hint">
          Clique no botão <strong>Filtros</strong> destacado para continuar.
        </p>
      ) : null}
      {(showBack || showPrimary) && (
        <div className="board-filters-tour-tooltip__footer">
          {showBack ? (
            <button type="button" className="board-filters-tour-tooltip__btn-back" {...backProps} />
          ) : (
            <span />
          )}
          {showPrimary ? (
            <button
              type="button"
              className="board-filters-tour-tooltip__btn-primary"
              {...primaryProps}
            />
          ) : null}
        </div>
      )}
      {showPrimary && !isLastStep && size > 1 ? (
        <p className="board-filters-tour-tooltip__progress">
          {index + 1} de {size}
        </p>
      ) : null}
    </div>
  );
}
